import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import SocialFoundation from '../../../../../foundation/components/Social';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import { SocialMediaPropType } from '../../TeamMember.types';
import './Social.css';
var defaultProps = {
  children: null,
  social: []
};
export default function Social(_ref) {
  var children = _ref.children,
    social = _ref.social;
  if (_isEmpty(social) && _isEmpty(children)) {
    return null;
  }
  if (!_isEmpty(social)) {
    return /*#__PURE__*/React.createElement(SocialFoundation, {
      className: "social"
    }, social.map(function (_ref2) {
      var url = _ref2.url,
        platform = _ref2.platform;
      if (_isEmpty(url) || _isEmpty(platform)) {
        return null;
      }
      return /*#__PURE__*/React.createElement(SocialFoundation.Platform, {
        key: platform + url,
        url: url,
        platform: platform
      }, /*#__PURE__*/React.createElement(SocialFoundation.Icon, {
        icon: platform.toLowerCase()
      }));
    }));
  }
  return /*#__PURE__*/React.createElement(SocialFoundation, {
    className: "social"
  }, children);
}
Social.defaultProps = defaultProps;
Social.Platform = SocialFoundation.Platform;
Social.Icon = SocialFoundation.Icon;
Social.Handle = SocialFoundation.Handle;
Social.Label = SocialFoundation.Label;